const tokensFR = {
    "view": {
        "title": "Historique des jetons",
        "table": {
            "column": {
                "quantity": "Quantite",
                "description": "Description",
                "type": "Type",
                "balance": "Solde",
                "date": "Date",
                "receipt": "Recu"
            },
            "placeholder": {
                "search": "Rechercher..."
            },
            "button": {
                "view": "Voir",
                "export_csv": "Exporter CSV",
                "order_tokens": "Commander des jetons"
            },
            "label": {
                "not_available": "Indisponible",
                "credit": "Credit",
                "debit": "Debit"
            }
        }
    },
    "order": {
        "title": "Commander des jetons",
        "form": {
            "label": {
                "quantity": "Quantite"
            },
            "placeholder": {
                "quantity": "Selectionner une quantite"
            },
            "help": {
                "quantity": "Nombre de jetons que vous souhaitez commander."
            },
            "validation": {
                "quantityRequired": "La quantite est obligatoire"
            },
            "button": {
                "placeOrder": "Passer la commande"
            },
            "option": {
                "tokensAmount": "{{count}} jetons"
            }
        },
        "modal": {
            "title": "Passer au paiement",
            "orderedPrefix": "Vous avez commande",
            "description": "Si vous souhaitez confirmer la commande, veuillez passer au paiement. Sinon, vous pouvez annuler la commande.",
            "button": {
                "cancel": "Annuler",
                "checkout": "Paiement"
            }
        },
        "message": {
            "error": "Une erreur est survenue ! Veuillez rafraichir la page et reessayer."
        }
    },
    "transaction": {
        "success": {
            "title": "Transaction reussie :)",
            "description": "Vous avez achete les jetons avec succes. Ils seront bientot ajoutes a votre compte !"
        },
        "cancel": {
            "title": "Transaction annulee :(",
            "description": "La transaction a ete annulee... Veuillez reessayer plus tard !"
        },
        "button": {
            "returnToDashboard": "Retour au tableau de bord"
        }
    }
};

export default tokensFR;
